import React, { useEffect, useState, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import * as NotificationAPI from '../../services/NotificationServices';
import styles from './styles/AcceptInvite.module.css';
import AuthContext from '../../context/AuthContext';
import Loading from '../loading/Loading';

const AcceptInvite = () => {
    const { userId } = useContext(AuthContext);
    const location = useLocation();
    const navigate = useNavigate();
    const [token, setToken] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');
        setToken(token);

        const verifyToken = async () => {
            try {
                const data = await NotificationAPI.verifyInviteToken(token);
                if (data.valid) {
                    if (userId) {
                        await NotificationAPI.acceptInviteFromLink(token);
                        navigate(`/my-classrooms/${data.classroomId}/d`);
                    } else {
                        navigate(location.pathname, { state: { showModal: true, authModalState: 'sign up', acceptInvite: true, from: location.pathname, token, classroomId: data.classroomId } });
                    }
                } else {
                    setError('Invalid or expired invite link.');
                }
            } catch (err) {
                setError('Invalid or expired invite link.');
            } finally {
                setIsLoading(false);
            }
        };

        if (token) {
            verifyToken();
        } else {
            setIsLoading(false);
        }
    }, [userId, location.pathname, location.search, navigate]);

    if (isLoading) {
        return <Loading/> 
    }

    if (error) {
        return <div className={styles.error}>{error}</div>;
    }

    return <Loading/>;
};

export default AcceptInvite;
